import { render, staticRenderFns } from "./send-notice-dialog.vue?vue&type=template&id=984eea28&scoped=true&"
import script from "./send-notice-dialog.vue?vue&type=script&lang=js&"
export * from "./send-notice-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-notice-dialog.vue?vue&type=style&index=0&id=984eea28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984eea28",
  null
  
)

export default component.exports